import { TRIPS, DISPATCH_STATUS_CODE } from '@/constants/index';
import { ITripBase } from '~/api/ITrip';

export const isComplete = (trip: ITripBase) => trip?.tripStatus === TRIPS.STATUS.COMPLETED &&
      ~~Number(trip?.status?.id) >= ~~Number(DISPATCH_STATUS_CODE.COMPLETE);

export const isCanceled = (trip: ITripBase) => ~~Number(trip?.tripStatus) < 0;

export const isUnassigned = (trip: ITripBase) => ~~Number(trip?.status?.id) < 0;

/**
 * True when a trip is bound to a unit — either fully Assigned (and past the
 * Assigned dispatch status) or Pre-Assigned. Pre-assigned trips are included
 * because they already occupy a unit/shift slot.
 */
export const isAssignedOrPreAssigned = (trip: ITripBase) => (
  trip?.tripStatus === TRIPS.STATUS.ASSIGNED &&
  ~~Number(trip?.status?.id) >= ~~Number(DISPATCH_STATUS_CODE.ASSIGNED)
) || trip?.tripStatus === TRIPS.STATUS.PRE_ASSIGNED;
